/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-floating-promises */
import {Carousel, Image} from 'antd';
import React, {useEffect, useRef, useState} from 'react';
import {Document, pdfjs} from 'react-pdf';

import Loader from '../../components/Loader/Loader';

const PdfRender: React.FC<{
  pdfUrl: string;
  handleImageLoad: (ref: any) => void;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setImgLoaded: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({pdfUrl, handleImageLoad, setPage, setImgLoaded}) => {
  const [numPages, setNumPages] = useState(null);
  const [pageImages, setPageImages] = useState<any[]>([]);
  const canvasRefs = useRef<any[]>([]);

  pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

  const onDocumentLoadSuccess = ({numPages}: {numPages: any}) => {
    setNumPages(numPages);
  };

  const renderPageToImage = async (
    pdfPage: any,
    canvas: any,
    pageNumber: number
  ) => {
    const context = canvas.getContext('2d');
    const viewport = pdfPage.getViewport({scale: 2});

    canvas.width = viewport.width;
    canvas.height = viewport.height;

    const renderContext = {
      canvasContext: context,
      viewport
    };

    await pdfPage.render(renderContext).promise;

    const image = canvas.toDataURL('image/png');
    setPageImages((prevImages: any[]) => {
      const newImages: any[] = [...prevImages];
      newImages[pageNumber - 1] = image;

      return newImages;
    });
  };

  useEffect(() => {
    if (numPages) {
      (async () => {
        const pdf = await pdfjs.getDocument(pdfUrl).promise;
        for (let i = 1; i <= numPages; i++) {
          const canvas = canvasRefs.current[i - 1];
          const page = await pdf.getPage(i);
          renderPageToImage(page, canvas, i);
        }
      })();
    }
  }, [numPages, pdfUrl]);

  return (
    <div>
      <Document
        file={pdfUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<Loader />}
      >
        <Image.PreviewGroup>
          <Carousel
            arrows
            infinite={false}
            afterChange={(curr) => {
              setPage(curr + 1);
              setImgLoaded(false);
            }}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <div key={`page_${index + 1}`}>
                {/* Hidden canvas to render the PDF page */}
                <canvas
                  ref={(el) => (canvasRefs.current[index] = el)}
                  style={{display: 'none'}}
                />

                {/* Display the rendered page as an image */}
                {pageImages[index] && (
                  <Image
                    src={pageImages[index]}
                    alt={`Page ${index + 1}`}
                    style={{
                      // backgroundColor: '#f3f7ff',
                      width: '100%',
                      height: '100%',
                      flex: 1
                    }}
                    onLoad={(ref) => {
                      handleImageLoad(ref?.target);
                    }}
                  />
                )}
              </div>
            ))}
          </Carousel>
        </Image.PreviewGroup>
      </Document>
    </div>
  );
};

export default PdfRender;
